var _circle, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _path4, _path5, _ellipse, _ellipse2, _g, _ellipse3, _path6, _path7, _path8, _path9, _rect33, _path10, _rect34, _path11, _path12, _path13, _path14, _path15, _g2, _rect35, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect36, _path28, _rect37, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse4, _circle2, _path38, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _g3, _path39, _path40, _path41, _path42, _path43, _g4, _path44, _path45, _ellipse5, _path46, _path47, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouseHomepage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 886,
    height: 487,
    viewBox: "0 0 886 487",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 443,
    cy: 548.998,
    r: 443,
    fill: "#E9F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M409.619 399.593V218.782L482.651 184.342V368.023L409.619 399.593Z",
    fill: "#FFDC53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M410.576 400.083V218.86L349.899 184.342V368.441L410.576 400.083Z",
    fill: "#FCBF1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M547.996 399.593V218.782L482.652 184.342V368.023L547.996 399.593Z",
    fill: "#FCBF1E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 465.994,
    y: 273.926,
    width: 27.1504,
    height: 52.1345,
    fill: "#FFDE86"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 456.053,
    y: 250.925,
    width: 27.1504,
    height: 52.1346,
    fill: "#FF997A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 458.729,
    y: 256.674,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 463.316,
    y: 256.675,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 467.906,
    y: 256.675,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 472.494,
    y: 256.675,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 477.084,
    y: 256.675,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 458.729,
    y: 263.193,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 463.316,
    y: 263.194,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 467.906,
    y: 263.194,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 472.494,
    y: 263.194,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 477.084,
    y: 263.194,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 458.729,
    y: 269.711,
    width: 1.91201,
    height: 3.45003,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 463.316,
    y: 269.712,
    width: 1.91201,
    height: 3.45003,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 467.906,
    y: 269.712,
    width: 1.91201,
    height: 3.45003,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 472.494,
    y: 269.712,
    width: 1.91201,
    height: 3.45003,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 477.084,
    y: 269.712,
    width: 1.91201,
    height: 3.45003,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 458.729,
    y: 276.223,
    width: 1.91201,
    height: 3.45003,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 463.316,
    y: 276.224,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 467.906,
    y: 276.224,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 472.494,
    y: 276.224,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 477.084,
    y: 276.224,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 458.729,
    y: 282.744,
    width: 1.91201,
    height: 3.45017,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 463.318,
    y: 282.743,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 467.906,
    y: 282.743,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 472.496,
    y: 282.743,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 477.084,
    y: 282.743,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 458.729,
    y: 289.261,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 463.316,
    y: 289.261,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 467.906,
    y: 289.261,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 472.494,
    y: 289.261,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 477.084,
    y: 289.261,
    width: 1.91201,
    height: 3.4501,
    rx: 0.3824,
    fill: "#DE7150"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M483.203 292.327V250.926",
    stroke: "#1E1548",
    strokeWidth: 0.960943,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M456.283 302.529V282.746",
    stroke: "#1E1548",
    strokeWidth: 0.960943,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.984,
    cy: 269.268,
    rx: 12.1795,
    ry: 12.2095,
    fill: "#F7B500"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_312_350",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 412,
    y: 257,
    width: 26,
    height: 25
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.984,
    cy: 269.268,
    rx: 12.1795,
    ry: 12.2095,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_312_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.33 258.406H431.007",
    stroke: "#FFDC53",
    strokeWidth: 0.960943,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.936 259.476H432.612",
    stroke: "#FFDC53",
    strokeWidth: 0.960943,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.086 260.684H431.677",
    stroke: "#FFDC53",
    strokeWidth: 0.960943,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.157 262.025L431.677 261.891",
    stroke: "#FFDC53",
    strokeWidth: 0.960943,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.96 263.366L431.677 263.299",
    stroke: "#FFDC53",
    strokeWidth: 0.960943,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.761 265.248L432.479 265.181C432.479 265.181 434.949 266.187 435.155 268.602C435.361 271.017 436.957 271.201 437.163 269.902C437.369 268.602 436.761 265.248 436.761 265.248Z",
    fill: "#FFD634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.92 257.596L429.266 257.73",
    stroke: "#FFDC53",
    strokeWidth: 0.960943,
    strokeLinecap: "square"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 423.109,
    cy: 269.268,
    rx: 12.1795,
    ry: 12.2094,
    fill: "#FCA81E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.57 342.931C366.57 342.931 422.714 263.74 434.9 267.169C447.087 270.598 449.492 283.852 461.507 279.593C473.523 275.333 481.322 293.926 491.042 305.061C500.762 316.196 513.412 343.095 513.412 343.095L366.57 342.931Z",
    fill: "#120136"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M474.539 283.904C468.936 277.399 462.714 279.292 462.714 279.292C462.714 279.292 452.036 282.281 445.727 285.826",
    stroke: "white",
    strokeWidth: 0.960943,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.016 341.859H381.694C381.694 341.859 376.178 333.78 383.16 331.302C390.143 328.825 385.505 323.549 389.413 320.664C393.321 317.78 400.359 320.092 401.783 317.984C403.206 315.876 400.809 311.232 407.016 312.812C413.223 314.392 407.016 341.859 407.016 341.859Z",
    fill: "#1E1548"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.143 320.569C478.143 320.569 483.273 326.412 485.082 331.303C486.89 336.193 486.638 332.162 491.042 334.178C495.446 336.193 490.794 340.34 494.235 339.353C497.677 338.365 498.641 341.86 498.641 341.86H478.068L478.143 320.569Z",
    fill: "#40BAD5"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 391.043,
    y: 310.341,
    width: 1.52963,
    height: 35.6509,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.273 323.376C388.826 323.123 378.242 308.234 384.069 305.276C389.896 302.318 388.636 294.171 391.808 294.878C394.98 295.584 398.16 300.101 398.141 303.059C398.122 306.017 400.144 305.447 400.144 309.51C400.144 313.574 393.719 323.63 391.273 323.376Z",
    fill: "#40BAD5"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 379.572,
    y: 306.509,
    width: 1.52959,
    height: 35.6509,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.801 319.543C377.355 319.29 372.532 315.326 374.955 311.876C377.378 308.426 366.77 304.4 372.598 301.442C378.425 298.484 372.631 291.042 378.425 291.875C384.218 292.709 384.256 295.526 384.237 298.484C384.218 301.442 388.673 301.614 388.673 305.677C388.673 309.74 384.218 309.397 384.218 312.834C384.218 316.271 382.248 319.796 379.801 319.543Z",
    fill: "#FF997A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M381.102 319.544C381.102 319.544 386.479 314.992 383.151 307.75",
    stroke: "#1E1548",
    strokeWidth: 0.960943,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M384.219 311.875C384.219 311.875 384.997 309.98 386.816 309.107C388.636 308.234 388.945 307.282 388.636 305.058C388.326 302.834 387.347 302.338 385.73 301.301",
    stroke: "#1E1548",
    strokeWidth: 0.960943,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.018 341.885V303.634L478.069 283.512V341.885H407.018Z",
    fill: "white",
    stroke: "#1E1548",
    strokeWidth: 0.960943
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_312_350",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 406,
    y: 282,
    width: 73,
    height: 61
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.018 341.885V303.634L478.069 283.512V341.885H407.018Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.960943
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_312_350)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.668,
    y: 303.25,
    width: 17.9728,
    height: 40.6343,
    rx: 1.5296,
    fill: "#1E1548"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.904,
    y: 303.25,
    width: 17.9728,
    height: 40.6343,
    rx: 1.5296,
    fill: "#FF997A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.9,
    y: 304.21,
    width: 23.3264,
    height: 8.43356,
    rx: 0.764801,
    fill: "#1E1548",
    stroke: "#1E1548",
    strokeWidth: 0.960943
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.652 304.209V312.642",
    stroke: "white",
    strokeWidth: 0.960943,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.798 308.424H437.124",
    stroke: "white",
    strokeWidth: 0.960943,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.613,
    y: 304.21,
    width: 11.8544,
    height: 16.8671,
    rx: 0.764801,
    fill: "#1E1548",
    stroke: "white",
    strokeWidth: 0.960943
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.334 304.206L469.628 321.076",
    stroke: "white",
    strokeWidth: 0.960943,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.892 308.423H475.364",
    stroke: "white",
    strokeWidth: 0.960943,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 457.304,
    cy: 320.888,
    rx: 0.956003,
    ry: 1.34171,
    fill: "#1E1548"
  }))), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 83.7595,
    height: 1.9164,
    rx: 0.3824,
    transform: "matrix(0.965766 -0.259414 0.258226 0.966085 401.783 303.413)",
    fill: "#FCBF1E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M406.947 332.107V304.21",
    stroke: "#1E1548",
    strokeWidth: 0.960943,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M399.967 306.118L456.187 291.173",
    stroke: "#1E1548",
    strokeWidth: 0.960943,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.885 331.813H399.776C399.699 331.813 399.661 331.928 399.661 332.081V332.35H391.019V332.081C391.019 331.928 390.942 331.813 390.904 331.813H389.795C389.719 331.813 389.68 331.928 389.68 332.081V332.35H381V332.081C381 331.928 380.923 331.813 380.885 331.813H379.776C379.7 331.813 379.662 331.928 379.662 332.081V332.35H370.752V332.081C370.752 331.928 370.713 331.813 370.637 331.813H369.49C369.451 331.813 369.375 331.928 369.375 332.081V341.55C369.375 341.703 369.451 341.818 369.49 341.818H370.599C370.675 341.818 370.713 341.703 370.713 341.55V339.863H379.547V341.512C379.547 341.665 379.623 341.78 379.662 341.78H380.771C380.847 341.78 380.885 341.665 380.885 341.512V339.863H389.489V341.512C389.489 341.665 389.566 341.78 389.604 341.78H390.713C390.789 341.78 390.828 341.665 390.828 341.512V339.863H399.432V341.512C399.432 341.665 399.508 341.78 399.546 341.78H400.655C400.732 341.78 400.77 341.665 400.77 341.512V339.71V338.598V336.643V335.531V333.615V332.465V332.081C401.038 331.928 400.961 331.813 400.885 331.813ZM399.623 333.726V335.413H391.019V333.726H399.623ZM389.604 335.413V333.726H381V335.413H389.604ZM379.623 333.726V335.413H370.752V333.726H379.623ZM370.752 336.792V338.479H379.585V336.792H370.752ZM381 338.479V336.792H389.604V338.479H381ZM391.019 336.792V338.479H399.623V336.792H391.019Z",
    fill: "#C5D4EB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.66 332.226H508.551C508.475 332.226 508.437 332.341 508.437 332.494V332.762H499.794V332.494C499.794 332.341 499.718 332.226 499.68 332.226H498.571C498.494 332.226 498.456 332.341 498.456 332.494V332.762H489.775V332.494C489.775 332.341 489.699 332.226 489.661 332.226H488.552C488.475 332.226 488.437 332.341 488.437 332.494V332.762H479.527V332.494C479.527 332.341 479.489 332.226 479.412 332.226H478.265C478.227 332.226 478.15 332.341 478.15 332.494V341.963C478.15 342.116 478.227 342.231 478.265 342.231H479.374C479.451 342.231 479.489 342.116 479.489 341.963V340.276H488.322V341.924C488.322 342.078 488.399 342.193 488.437 342.193H489.546C489.622 342.193 489.661 342.078 489.661 341.924V340.276H498.265V341.924C498.265 342.078 498.341 342.193 498.379 342.193H499.488C499.565 342.193 499.603 342.078 499.603 341.924V340.276H508.207V341.924C508.207 342.078 508.284 342.193 508.322 342.193H509.431C509.507 342.193 509.545 342.078 509.545 341.924V340.122V339.011V337.056V335.944V334.027V332.877V332.494C509.813 332.341 509.737 332.226 509.66 332.226ZM508.398 334.141V335.828H499.794V334.141H508.398ZM498.379 335.828V334.141H489.775V335.828H498.379ZM488.399 334.141V335.828H479.527V334.141H488.399ZM479.527 337.21V338.897H488.36V337.21H479.527ZM489.775 338.897V337.21H498.379V338.897H489.775ZM499.794 337.21V338.897H508.398V337.21H499.794Z",
    fill: "#C5D4EB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M461.15 289.62L473.969 286.385",
    stroke: "#1E1548",
    strokeWidth: 0.960943,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.71 335.414C465.71 335.414 465.253 325.474 468.568 328.642C471.883 331.811 467.674 341.883 467.674 341.883L466.231 341.816",
    fill: "#1E1548"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M465.71 335.414C465.71 335.414 465.253 325.474 468.568 328.642C471.883 331.811 467.674 341.883 467.674 341.883L466.231 341.816",
    stroke: "#1E1548",
    strokeWidth: 0.960943,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.441 341.816C463.687 339.255 461.269 334.582 463.751 333.728C466.232 332.874 466.232 341.816 466.232 341.816",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M464.441 341.816C463.687 339.255 461.269 334.582 463.751 333.728C466.232 332.874 466.232 341.816 466.232 341.816",
    stroke: "#1E1548",
    strokeWidth: 0.960943
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M462.551 341.814C462.551 341.814 462.551 339.565 461.264 339.373",
    stroke: "#1E1548",
    strokeWidth: 0.960943,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M415.391 341.859C415.391 341.859 415.673 339.323 417.303 338.479",
    stroke: "#1E1548",
    strokeWidth: 0.960943,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M414.291 341.82C414.291 341.82 413.659 331.916 418.248 329.898",
    stroke: "#1E1548",
    strokeWidth: 0.960943,
    strokeLinecap: "round"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 408.561,
    y: 334.327,
    width: 2.90624,
    height: 67.7366,
    fill: "#1E1548"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.996 357.354C404.348 356.873 384.238 328.583 395.309 322.963C406.381 317.343 403.987 301.864 410.013 303.207C416.04 304.549 422.083 313.131 422.046 318.752C422.01 324.372 425.852 323.289 425.852 331.009C425.852 338.729 413.644 357.835 408.996 357.354Z",
    fill: "#40BAD5"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 508.564,
    y: 325.609,
    width: 2.44736,
    height: 57.0413,
    fill: "#1E1548"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.932 339.14C505.017 338.735 497.302 332.393 501.178 326.873C505.055 321.353 488.082 314.912 497.406 310.179C506.729 305.446 497.46 293.538 506.729 294.872C515.999 296.205 516.06 300.713 516.029 305.446C515.999 310.179 523.126 310.453 523.126 316.954C523.126 323.455 515.999 322.907 515.999 328.406C515.999 333.906 512.846 339.545 508.932 339.14Z",
    fill: "#FF997A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M511.012 339.142C511.012 339.142 519.616 331.859 514.29 320.272",
    stroke: "#1E1548",
    strokeWidth: 1.38376,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M515.998 326.876C515.998 326.876 517.243 323.844 520.154 322.446C523.065 321.049 523.56 319.527 523.065 315.968C522.57 312.41 521.003 311.616 518.416 309.957",
    stroke: "#1E1548",
    strokeWidth: 1.38376,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.108 235.013C497.738 237.534 495.826 229.687 501.37 230.949C506.915 232.211 505.959 238.87 510.548 238.87C515.137 238.87 521.255 242.371 521.255 242.371H476.801C476.801 242.371 484.478 232.493 491.108 235.013Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.693 211.897C432.693 211.897 436.049 208.939 437.923 209.925C439.797 210.911 446.459 205.944 448.463 211.897C438.592 211.897 432.693 211.897 432.693 211.897Z",
    fill: "#FFFDFD"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.416 265.326C365.416 265.326 375.806 255.504 381.071 257.467C389.292 260.534 392.736 255.733 396.375 257.467C398.455 258.459 400.952 263.706 406.236 261.09C409.254 259.595 412.318 261.332 410.37 265.584C417.7 265.326 365.416 265.326 365.416 265.326Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.811 310.044C350.811 310.044 358.86 305.462 363.444 323.095C368.028 340.727 366.248 324.776 374.181 328.719C382.114 332.661 373.733 340.774 379.933 338.842C386.132 336.91 387.87 343.745 387.87 343.745H350.811V310.044Z",
    fill: "#92C281"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.021 367.839C548.021 367.839 556.071 363.258 560.655 380.89C565.239 398.522 563.459 382.571 571.392 386.514C579.324 390.457 570.944 398.569 577.144 396.637C583.343 394.705 585.08 401.54 585.08 401.54H548.021V367.839Z",
    fill: "#92C281"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.809 310.04C350.809 310.04 343.872 313.525 340.615 323.091C337.358 332.658 337.811 324.772 329.878 328.715C321.945 332.658 330.325 340.77 324.126 338.838C317.926 336.906 316.189 343.742 316.189 343.742H353.248L350.809 310.04Z",
    fill: "#92C281"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 474.424,
    cy: 445.997,
    rx: 160.161,
    ry: 11.7191,
    fill: "#C1D4ED"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.883,
    cy: 353.238,
    r: 25.2962,
    transform: "rotate(-34.7654 601.883 353.238)",
    fill: "#FFDC53"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.18 356.18L604.181 363.965C604.181 364.812 602.817 365.717 601.969 365.716C601.122 365.716 599.872 364.812 599.872 363.964L599.871 356.18L592.086 356.178C591.238 356.178 590.271 354.653 590.271 353.806C590.271 352.958 591.238 351.869 592.085 351.869L599.87 351.87L599.868 342.8C599.868 341.952 601.118 341.289 601.965 341.289C602.813 341.289 604.177 341.953 604.178 342.801L604.179 351.871L611.963 351.872C612.811 351.872 613.605 352.962 613.605 353.81C613.605 354.657 612.812 356.182 611.964 356.182L604.18 356.18Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 577.492,
    cy: 273.944,
    r: 6.81052,
    transform: "rotate(-34.7654 577.492 273.944)",
    fill: "#C1D4ED"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 568.766,
    cy: 328.125,
    r: 4.86466,
    transform: "rotate(-34.7654 568.766 328.125)",
    fill: "#FF8A7A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 488.579,
    cy: 414.517,
    r: 4.86466,
    transform: "rotate(-34.7654 488.579 414.517)",
    fill: "#DDEBFF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.361,
    cy: 386.689,
    r: 2.91879,
    transform: "rotate(-34.7654 583.361 386.689)",
    fill: "#120136"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 607.779,
    cy: 296.89,
    r: 2.91879,
    transform: "rotate(-34.7654 607.779 296.89)",
    fill: "#40BAD5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.147,
    cy: 206.812,
    r: 33.7096,
    fill: "#40BAD5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_312_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.025 218.484C353.129 220.996 352.062 222.316 351.337 222.316C350.185 222.316 348.222 219.038 347.326 212.864H352.66L352.574 212.566C352.361 211.629 352.446 210.692 352.83 209.84H347.027C346.942 208.648 346.899 207.371 346.899 206.008C346.899 204.646 346.942 203.368 347.027 202.218H355.689C355.775 203.411 355.817 204.688 355.817 206.008C355.817 206.434 355.817 206.86 355.817 207.286C356.159 207.2 356.5 207.158 356.841 207.158C357.183 207.158 357.524 207.2 357.865 207.286L358.847 207.541C358.89 207.03 358.89 206.519 358.89 206.008C358.89 204.731 358.847 203.453 358.762 202.218H367.253C367.552 203.411 367.722 204.688 367.722 206.008C367.722 207.2 367.552 208.393 367.296 209.542L370.112 210.224C370.197 210.224 370.283 210.266 370.325 210.309C370.624 208.946 370.795 207.498 370.795 206.008C370.795 195.278 362.047 186.591 351.337 186.591C340.627 186.591 331.922 195.278 331.922 206.008C331.922 216.738 340.669 225.425 351.38 225.425C352.83 225.425 354.281 225.255 355.647 224.956C355.647 224.914 355.604 224.871 355.604 224.786L354.025 218.484ZM366.186 199.11H358.463C357.993 195.661 357.183 192.595 355.988 190.296C360.511 191.659 364.223 194.895 366.186 199.11ZM351.337 189.657C352.489 189.657 354.452 192.936 355.348 199.11H347.369C348.222 192.936 350.185 189.657 351.337 189.657ZM334.994 206.008C334.994 204.688 335.165 203.411 335.464 202.218H343.955C343.87 203.453 343.784 204.731 343.784 206.008C343.784 207.286 343.827 208.563 343.955 209.84H335.421C335.165 208.606 334.994 207.328 334.994 206.008ZM336.53 212.906H344.254C344.723 216.313 345.534 219.421 346.728 221.678C342.205 220.315 338.493 217.079 336.53 212.906ZM344.254 199.11H336.53C338.493 194.895 342.205 191.659 346.728 190.339C345.576 192.595 344.723 195.704 344.254 199.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.159 223.124L366.313 217.333L369.641 215.63C370.708 215.076 370.537 213.501 369.343 213.202L357.096 210.264C356.157 210.052 355.304 210.903 355.517 211.84L358.547 224.061C358.846 225.253 360.425 225.423 360.979 224.359L362.686 221.037L368.489 226.828C368.788 227.126 369.3 227.126 369.641 226.828L372.202 224.273C372.458 223.975 372.458 223.464 372.159 223.124Z",
    fill: "white"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.816 294.15C228.816 294.15 236.358 263.398 258.397 258.284C280.436 253.169 301.15 284.252 303.519 290.974C305.888 297.696 309.228 315.727 297.465 322.768C285.702 329.809 278.858 309.75 278.858 309.75C278.858 309.75 283.057 325.82 271.317 330.651C259.576 335.481 257.798 329.826 256.697 330.875C242.428 344.477 236.09 331.593 236.09 331.593L228.816 294.15Z",
    fill: "#BD8565"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M255.38 335.777C255.38 335.777 259.698 327.273 254.124 308.392",
    stroke: "white",
    strokeWidth: 2.2473,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M278.929 329.46C278.929 329.46 283.247 320.956 277.673 302.075",
    stroke: "white",
    strokeWidth: 2.2473,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.309 378.553C130.309 378.553 180.132 393.224 193.128 406.858C193.582 406.425 208.49 361.255 237.28 341.867C266.07 322.479 310.547 269.437 286.377 253.443C262.206 237.449 269.27 291.041 241.259 296.45C213.247 301.86 257.524 255.686 268.414 259.5C272.615 251.463 280.34 256.404 280.34 256.404C280.34 256.404 315.365 233.054 329.959 230.136C344.553 227.217 350.391 210.676 329.959 210.676C309.528 210.676 271.056 226.821 262.827 230.135C242.481 238.331 230.963 235.294 223.536 242.374C216.108 249.454 206.22 242.32 199.907 253.069C193.593 263.819 185.761 290.555 174.199 312.917C162.637 335.278 129.128 377.314 129.128 377.314",
    fill: "#E6A47F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_312_350",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 227,
    width: 220,
    height: 180
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.309 378.553C130.309 378.553 180.132 393.224 193.128 406.858C193.582 406.425 208.49 361.254 237.28 341.867C266.07 322.479 310.547 269.437 286.377 253.443C262.206 237.449 269.27 291.041 241.259 296.45C213.247 301.86 257.524 255.686 268.414 259.5C272.615 251.463 281.342 260.618 281.342 260.618C281.342 260.618 351.364 258.35 348.423 246.408C346.249 237.579 294.662 232.799 272.471 228.75C250.28 224.701 230.963 235.294 223.536 242.374C216.108 249.454 206.22 242.32 199.907 253.069C193.593 263.819 185.761 290.555 174.199 312.917C162.637 335.278 129.128 377.314 129.128 377.314",
    fill: "#D2BEB2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_312_350)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.501 405.292C192.501 405.292 207.486 358.735 216.095 353.633C224.704 348.53 230.476 346.184 237.28 341.868C244.083 337.553 205.344 403.788 205.344 403.788",
    fill: "#BD8565"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.536 242.375C223.536 242.375 206.138 271.971 206.138 271.971C206.138 271.971 216.944 243.796 210.289 242.324C203.634 240.853 223.536 242.375 223.536 242.375Z",
    fill: "#BD8565"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.995 258.946C268.995 258.946 271.133 234.435 287.86 244.537C304.587 254.64 292.016 274.637 292.016 274.637",
    fill: "#BD8565"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.52 263.038C267.52 263.038 269.659 238.527 286.386 248.63C303.113 258.732 290.542 278.729 290.542 278.729",
    fill: "#E6A47F"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.263,
    cy: 427.05,
    rx: 46.0697,
    ry: 4.49461,
    fill: "#C1D4ED"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M207.238 270.874C212.107 260.761 222.745 239.636 226.34 236.04",
    stroke: "white",
    strokeWidth: 2.2473
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M269.039 257.392L270.102 257.756C270.108 257.74 270.113 257.725 270.117 257.709L269.039 257.392ZM239.824 296.72C239.572 297.815 239.573 297.815 239.575 297.816C239.576 297.816 239.577 297.816 239.579 297.817C239.581 297.817 239.584 297.818 239.587 297.818C239.593 297.82 239.6 297.821 239.608 297.823C239.624 297.826 239.644 297.83 239.667 297.834C239.713 297.842 239.774 297.852 239.848 297.862C239.997 297.881 240.201 297.9 240.457 297.905C240.97 297.915 241.687 297.873 242.576 297.677C244.361 297.285 246.802 296.287 249.667 293.937C255.375 289.253 262.767 279.196 270.102 257.756L267.976 257.028C260.703 278.287 253.488 287.894 248.241 292.199C245.628 294.344 243.504 295.172 242.094 295.482C241.386 295.638 240.847 295.665 240.503 295.658C240.331 295.655 240.208 295.642 240.136 295.633C240.1 295.628 240.076 295.624 240.066 295.623C240.061 295.622 240.06 295.621 240.062 295.622C240.062 295.622 240.064 295.622 240.067 295.623C240.068 295.623 240.069 295.623 240.071 295.624C240.072 295.624 240.073 295.624 240.074 295.624C240.075 295.625 240.077 295.625 239.824 296.72ZM270.117 257.709C272.902 248.241 277.176 243.867 281.878 243.626C284.279 243.503 287.015 244.421 290.027 246.609C293.038 248.795 296.256 252.203 299.583 256.917L301.419 255.621C298.005 250.783 294.622 247.168 291.347 244.79C288.074 242.413 284.84 241.224 281.763 241.382C275.51 241.703 270.795 247.442 267.961 257.075L270.117 257.709Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_312_350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.4515,
    height: 40.4515,
    fill: "white",
    transform: "translate(331.922 186.587)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseHomepage);
export default __webpack_public_path__ + "static/media/house-homepage.d65f8188.svg";
export { ForwardRef as ReactComponent };